var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5779_6604",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 78,
    height: 78
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 77C61.3305 77 77 61.3305 77 42C77 22.6695 61.3305 7 42 7C22.6695 7 7 22.6695 7 42C7 61.3305 22.6695 77 42 77Z",
    fill: "#555555",
    stroke: "white",
    strokeWidth: 7,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9011 32.1016L32.1016 51.9011M32.1016 32.1016L51.9011 51.9011",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5779_6604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H84V84H0V0Z",
    fill: "#724AE8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.f5e7c0cf83a157db6643e0421959b970.svg";
export { ForwardRef as ReactComponent };